import i18n from "i18n";
import { useCallback, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { DataLakeQuery } from "@graylog/enterprise-api";
import { PREVIEW_JOB_STATUS } from "data-lake/preview/Constants";
import { defaultOnError } from "util/conditional/onError";
const useJobProgress = (mostRecentJobIds, initialSearchJobStatus, executedSearchId) => {
  const [isQueryEnabled, setEnableProgressFetching] = useState(initialSearchJobStatus !== PREVIEW_JOB_STATUS.done);
  const fetchJobProgress = useCallback(async (searchId) => {
    const result = await DataLakeQuery.searchJobExecutionStateByjob_id(searchId);
    if (result.status !== PREVIEW_JOB_STATUS.running) {
      setEnableProgressFetching(false);
    }
    return result;
  }, []);
  const { data } = useQuery({
    queryKey: ["data-lake", "progress", executedSearchId, mostRecentJobIds],
    queryFn: () => defaultOnError(
      fetchJobProgress(mostRecentJobIds.asyncSearchId),
      i18n.t("notifications.fetch_search_progress_failed", { ns: "enterprise_data_lake" })
    ),
    refetchInterval: 200,
    gcTime: 0,
    enabled: !!(isQueryEnabled && executedSearchId && (mostRecentJobIds == null ? void 0 : mostRecentJobIds.asyncSearchId) && (mostRecentJobIds == null ? void 0 : mostRecentJobIds.searchId) === executedSearchId),
    initialData: initialSearchJobStatus === PREVIEW_JOB_STATUS.done ? { status: PREVIEW_JOB_STATUS.done, progress: 100 } : void 0
  });
  return {
    data,
    setEnableProgressFetching: (newVal) => {
      setEnableProgressFetching(newVal);
    }
  };
};
export default useJobProgress;
